var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputeCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 12.4728L14.4087 12.2314C16.7171 9.92286 20.46 9.92286 22.7685 12.2314C25.0771 14.5399 25.0771 18.2828 22.7685 20.5913L19.4246 23.9352C17.1161 26.2438 13.3732 26.2438 11.0647 23.9352C8.75618 21.6267 8.75618 17.8838 11.0647 15.5753L11.6064 15.0336",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3935 12.9662L23.9352 12.4246C26.2438 10.116 26.2438 6.37317 23.9352 4.06464C21.6267 1.75612 17.8838 1.75612 15.5753 4.06464L12.2314 7.40861C9.92286 9.71713 9.92286 13.46 12.2314 15.7685C14.5399 18.0771 18.2828 18.0771 20.5913 15.7685L20.8327 15.5271",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24998 4.66675L6.99998 7.00008M2.33331 9.33341L5.83331 10.5001M3.49998 15.7501L5.83331 14.0001",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeCenter);
export default __webpack_public_path__ + "static/media/Dispute-Center.4761cd7003a61d8f2fdbe3b391a05d6d.svg";
export { ForwardRef as ReactComponent };